<script lang="ts">
  import { onMount } from "svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import { Table } from "../../components/Table";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { customerDtoFields } from "../../utils/TableFields/customer-dto.fields";

  import { filter, loading, records, pagination, initList, onCreate, onEdit, onDelete, onPageChange, search } from "./customer.store";

  onMount(initList);
</script>

<MainLayout>
  <SearchHeader
    entitySingular="cliente"
    entityPlural="clienti"
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    bind:searchValue={$filter.criteria.name}
    on:search={search}
  />

  <Table
    loading={$loading}
    fields={customerDtoFields}
    records={$records}
    pagination={$pagination}
    createEnabled={true}
    editEnabled={true}
    deleteEnabled={true}
    on:create={(_) => onCreate()}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</MainLayout>
